import { render } from "./PaymentResultPanel.vue?vue&type=template&id=7e004daf&scoped=true&ts=true"
import script from "./PaymentResultPanel.vue?vue&type=script&lang=ts"
export * from "./PaymentResultPanel.vue?vue&type=script&lang=ts"

import "./PaymentResultPanel.vue?vue&type=style&index=0&id=7e004daf&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e004daf"]])

export default __exports__